document.addEventListener("DOMContentLoaded", () => {
  const slot = document.getElementById("af-ad-1");
  if (!slot || slot.childElementCount) return; // already filled server-side (snippets/af-promo-ads.liquid)
  slot.innerHTML += `
  <div class="shopify-section cc-media-with-text">
     <div class="section section--full-width section--padded ">
        <div class="container" style="padding: 0;">
           <div class="media-with-text" style="--media-width: 50%">
              <div class="media-with-text__media relative flex flex-col justify-center overflow-hidden" style="--media-scale: 1.0">
                 <div class="media w-full relative">
    				<img alt="Gas grill vs Arteflame: a dry, overcooked steak seared at 500°F on a gas grill next to a juicy steak seared at 1,000°F on an Arteflame" width="720" height="720" decoding="async" data-af-lazy-img="" data-src="https://cdn.shopify.com/s/files/1/2541/1976/files/gas-vs-arteflame-m_16bed15e-2b32-45f5-b77e-92e87fe5a13d.jpg?v=1790896582">
                 </div>
              </div>
              <div class="media-with-text__text flex flex-col justify-center">
                 <div class="text-start">
                    <h2 class="section__block section__block--heading h3" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_qq8yti__heading_aMtrHk&quot;,&quot;domId&quot;:&quot;heading_aMtrHk&quot;,&quot;type&quot;:&quot;heading&quot;}">
                       The Sear Makes the Steak, And Arteflame Makes the Sear
                    </h2>
                    <div class="section__block reading-width rte" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_qq8yti__text_Gtggtc&quot;,&quot;domId&quot;:&quot;text_Gtggtc&quot;,&quot;type&quot;:&quot;text&quot;}" data-live-text-setting="template--17964617203769__media_with_text_qq8yti__text_Gtggtc.text">
                       <p>A typical gas grill runs cooler, so a steak needs more time over the heat before it browns. The Arteflame’s center grate reaches 1,000°F, so you get a deep crust fast while the inside stays juicy.</p>
                       <div class="section__block section__block--button">
  						<a class="btn btn--primary" href="/collections/grills" style="text-decoration: none;">Shop Wood-Fired Grills</a>
                        </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  `;
});

document.addEventListener("DOMContentLoaded", () => {
  const slot = document.getElementById("af-ad-2");
  if (!slot || slot.childElementCount) return; // already filled server-side (snippets/af-promo-ads.liquid)
  slot.innerHTML += `
  <div class="shopify-section cc-media-with-text">
     <div class="section section--full-width section--padded ">
        <div class="container" style="padding: 0;">
           <div class="media-with-text media-with-text--reverse" style="--media-width: 50%">
              <div class="media-with-text__media relative flex flex-col justify-center overflow-hidden" style="--media-scale: 1.0">
                 <div class="media w-full relative">
  				<video playsinline="" muted="" loop="" controlslist="nodownload" disablepictureinpicture="" preload="none" data-af-lazy-video="" style="width: 100%; height: 100%" data-poster="https://cdn.shopify.com/s/files/1/2541/1976/files/arteflame-steakhouse-quality.jpg?v=1732821957">
  					<source src="https://cdn.shopify.com/videos/c/o/v/292df5cdc5924ea7b50d1a2f7b4a36b9.mp4" type="video/mp4">
  				</video>
                 </div>
              </div>
              <div class="media-with-text__text flex flex-col justify-center">
                 <div class="text-start">
                    <h2 class="section__block section__block--heading h3" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_WaJncx__heading_kYgbTW&quot;,&quot;domId&quot;:&quot;heading_kYgbTW&quot;,&quot;type&quot;:&quot;heading&quot;}">
                       A 1,000°F Sear for a Steakhouse-Style Crust
                    </h2>
                    <div class="section__block reading-width rte" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_WaJncx__text_xNMYfP&quot;,&quot;domId&quot;:&quot;text_xNMYfP&quot;,&quot;type&quot;:&quot;text&quot;}" data-live-text-setting="template--17964617203769__media_with_text_WaJncx__text_xNMYfP.text">
                       <p>The Arteflame’s center grill grate reaches 1,000°F, the kind of intense, direct heat steakhouses sear with, so you get a crisp crust while the inside stays as rare as you like it.</p>
                       <div class="section__block section__block--button">
  						<a class="btn btn--primary" href="/collections/xxl-40-inch-grills" style="text-decoration: none;">Shop 40″ Grill &amp; Griddle Combos</a>
                        </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  `;
});

document.addEventListener("DOMContentLoaded", () => {
  const slot = document.getElementById("af-ad-3");
  if (!slot || slot.childElementCount) return; // already filled server-side (snippets/af-promo-ads.liquid)
  slot.innerHTML += `
  <div class="shopify-section cc-media-with-text">
     <div class="section section--full-width section--padded ">
        <div class="container" style="padding: 0;">
           <div class="media-with-text" style="--media-width: 50%">
              <div class="media-with-text__media relative flex flex-col justify-center overflow-hidden" style="--media-scale: 1.0">
                 <div class="media w-full relative">
  				<video playsinline="" muted="" loop="" controlslist="nodownload" disablepictureinpicture="" preload="none" data-af-lazy-video="" style="width: 100%; height: 100%" data-poster="https://cdn.shopify.com/s/files/1/2541/1976/files/arteflame-temperature.jpg?v=1732887759">
  					<source src="https://cdn.shopify.com/videos/c/o/v/91d3935a78c14a03a9c07007129dbc61.mp4" type="video/mp4">
  				</video>
                 </div>
              </div>
              <div class="media-with-text__text flex flex-col justify-center">
                 <div class="text-start">
                    <h2 class="section__block section__block--heading h3" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_qq8yti__heading_aMtrHk&quot;,&quot;domId&quot;:&quot;heading_aMtrHk&quot;,&quot;type&quot;:&quot;heading&quot;}">
                       Cook Everything, All at Once
                    </h2>
                    <div class="section__block reading-width rte" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_qq8yti__text_Gtggtc&quot;,&quot;domId&quot;:&quot;text_Gtggtc&quot;,&quot;type&quot;:&quot;text&quot;}" data-live-text-setting="template--17964617203769__media_with_text_qq8yti__text_Gtggtc.text">
                       <p>The Arteflame’s cooktop is hottest at the center and cooler toward the edge, so you have several temperature zones at once. Sear steaks in the middle while vegetables and delicate fish cook more gently further out.</p>
                       <div class="section__block section__block--button">
  						<a class="btn btn--primary" href="/collections/grills" style="text-decoration: none;">Shop Grill &amp; Griddle Combos</a>
                        </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  `;
});

document.addEventListener("DOMContentLoaded", () => {
  const slot = document.getElementById("af-ad-4");
  if (!slot || slot.childElementCount) return; // already filled server-side (snippets/af-promo-ads.liquid)
  slot.innerHTML += `
  <div class="shopify-section cc-media-with-text">
     <div class="section section--full-width section--padded ">
        <div class="container" style="padding: 0;">
           <div class="media-with-text media-with-text--reverse" style="--media-width: 50%">
              <div class="media-with-text__media relative flex flex-col justify-center overflow-hidden" style="--media-scale: 1.0">
                 <div class="media w-full relative">
  				<video playsinline="" muted="" loop="" controlslist="nodownload" disablepictureinpicture="" preload="none" data-af-lazy-video="" style="width: 100%; height: 100%" data-poster="https://cdn.shopify.com/s/files/1/2541/1976/files/arteflame-social-grill_afded339-aa4d-4519-a105-330cd007d95e.jpg?v=1732889342">
  					<source src="https://cdn.shopify.com/videos/c/o/v/315a92e2b0d14428ae75db6f63e4d499.mp4" type="video/mp4">
  				</video>
                 </div>
              </div>
              <div class="media-with-text__text flex flex-col justify-center">
                 <div class="text-start">
                    <h2 class="section__block section__block--heading h3" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_WaJncx__heading_kYgbTW&quot;,&quot;domId&quot;:&quot;heading_kYgbTW&quot;,&quot;type&quot;:&quot;heading&quot;}">
                       The Social Grill
                    </h2>
                    <div class="section__block reading-width rte" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_WaJncx__text_xNMYfP&quot;,&quot;domId&quot;:&quot;text_xNMYfP&quot;,&quot;type&quot;:&quot;text&quot;}" data-live-text-setting="template--17964617203769__media_with_text_WaJncx__text_xNMYfP.text">
                       <p>Arteflame’s round design makes grilling a shared joy. Gather around the grill, enjoy seamless conversations, and turn every cooking session into a fun and engaging event with family and friends.</p>
                    </div>
  					<div class="section__block section__block--button">
  						<a class="btn btn--primary" href="/collections/fire-pits" style="text-decoration: none;">Shop Fire Pit Grills</a>
  					</div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  `;
});

document.addEventListener("DOMContentLoaded", () => {
  const slot = document.getElementById("af-ad-5");
  if (!slot || slot.childElementCount) return; // already filled server-side (snippets/af-promo-ads.liquid)
  slot.innerHTML += `
  <div class="shopify-section cc-media-with-text">
     <div class="section section--full-width section--padded ">
        <div class="container" style="padding: 0;">
           <div class="media-with-text" style="--media-width: 50%">
              <div class="media-with-text__media relative flex flex-col justify-center overflow-hidden" style="--media-scale: 1.0">
                 <div class="media w-full relative">
  				<video playsinline="" muted="" loop="" controlslist="nodownload" disablepictureinpicture="" preload="none" data-af-lazy-video="" style="width: 100%; height: 100%" data-poster="https://cdn.shopify.com/s/files/1/2541/1976/files/arteflame-temperature.jpg?v=1732887759">
  					<source src="https://cdn.shopify.com/videos/c/o/v/228f66c03d9a46eca583c05fa5aca631.mp4" type="video/mp4">
  				</video>
                 </div>
              </div>
              <div class="media-with-text__text flex flex-col justify-center">
                 <div class="text-start">
                    <h2 class="section__block section__block--heading h3" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_qq8yti__heading_aMtrHk&quot;,&quot;domId&quot;:&quot;heading_aMtrHk&quot;,&quot;type&quot;:&quot;heading&quot;}">
                       Sear, Grill and Gather on One Grill
                    </h2>
                    <div class="section__block reading-width rte" data-shopify-editor-block="{&quot;id&quot;:&quot;template--17964617203769__media_with_text_qq8yti__text_Gtggtc&quot;,&quot;domId&quot;:&quot;text_Gtggtc&quot;,&quot;type&quot;:&quot;text&quot;}" data-live-text-setting="template--17964617203769__media_with_text_qq8yti__text_Gtggtc.text">
                       <p>The Arteflame grill pairs a sculptural design with a solid steel flat-top cooktop. Food cooks on the steel rather than over open flames, so dripping fat doesn’t cause flare-ups, and the heat zones let you cook several dishes at once.</p>
                       <div class="section__block section__block--button">
  						<a class="btn btn--primary" href="/collections/grills" style="text-decoration: none;">Shop Wood-Fired Grills</a>
                        </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  `;
});

// Perf: the promo videos above sit far down each recipe. Load and play them only when one scrolls
// near the screen, so they don't compete with the recipe photo while the page loads.
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video[data-af-lazy-video]");
  const start = (v) => {
    if (v.dataset.poster) v.poster = v.dataset.poster;
    v.preload = "auto";
    v.autoplay = true;
    v.load();
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };
  if (!("IntersectionObserver" in window)) { videos.forEach(start); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { io.unobserve(e.target); start(e.target); }
    });
  }, { rootMargin: "300px 0px" });
  videos.forEach((v) => io.observe(v));
});

// Perf: the promo image in the first ad slot sits just below the first screen on best-buy guides, close
// enough that loading="lazy" still fetched it while the hero image (the page's LCP) was loading. Wait for
// the page's load event, then load it as it nears the screen. width/height reserve its space meanwhile.
window.addEventListener("load", () => {
  const imgs = document.querySelectorAll("img[data-af-lazy-img]");
  const show = (img) => {
    img.src = img.dataset.src;
    img.removeAttribute("data-af-lazy-img");
  };
  if (!("IntersectionObserver" in window)) { imgs.forEach(show); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { io.unobserve(e.target); show(e.target); }
    });
  }, { rootMargin: "300px 0px" });
  imgs.forEach((img) => io.observe(img));
});
